import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';

const httpLink = new HttpLink({
  uri: process.env.GRAPHQL_URI,
  fetch: function (uri, options) {
    const headers = options?.headers as Record<string, any>;
    const revalidate = headers?.revalidate as number;

    if (typeof revalidate === 'number') {
      return fetch(uri, {
        ...(options ?? {}),
        headers: {
          ...(options?.headers ?? {}),
        },
        next: {
          revalidate: revalidate,
        },
      });
    }

    return fetch(uri, {
      ...(options ?? {}),
      headers: {
        ...(options?.headers ?? {}),
      },
      cache: 'no-cache',
    });
  },
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  // TODO: 모든 GraphQL 에러를 notify 하는 로직을 여기에 추가하면 좋을듯
  // if (graphQLErrors) {
  //   console.error('GraphQL Error:', graphQLErrors);
  // }
  // if (networkError) {
  //   console.error('Network Error:', networkError);
  // }
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([errorLink, httpLink]),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    mutate: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
  },
});

export default client;
